import React, { useCallback } from 'react';
import { detailedComputeCostByTypeData } from "service/service";
import ComputeHierarchyBase, { FetchServiceParams } from './ComputeHierarchyBase';

const ComputeCostDetails = () => {
    const serviceFunc = useCallback((params: FetchServiceParams) => {
        return detailedComputeCostByTypeData({
            startDate: params.startDate,
            endDate: params.endDate,
            env: params.env,
            sector: params.sector,
            location: params.location,
            computeType: params.computeType,
            page: params.page,
            pageSize: params.pageSize,
            filters: params.filters,
            selectedDateInString: params.apiDateRangeKey
        });
    }, []);

    return (
        <ComputeHierarchyBase
            serviceFunc={serviceFunc}
            pageTitle="Compute Cost Details"
            tableTitlePrefix="Total Compute Cost"
            columnLabel="Compute Cost"
            isCurrency={true}
            preserveFilterKey="compute_cost_filters"
            detailPath="/databricksADB/Cost/detail_table"
            tableType="compute-cost-details"
        />
    );
};

export default ComputeCostDetails;